function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactDOM from 'react-dom';
import { WDHComponent } from '../../../../../wdh-foundation/wdh';
import AccordionSpot from './react-accordion-spot';
/**
 * @memberOf module:wdh-accordion-spot
 */
var WDHAccordionSpot = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHAccordionSpot() {
    var _this;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'accordion-spot';
    _classCallCheck(this, WDHAccordionSpot);
    _this = _callSuper(this, WDHAccordionSpot, [className]);

    /**
     * The react component to render
     * @property {React.Component} [reactApp=AccordionSpot]
     */
    _this.reactApp = AccordionSpot;

    /**
     * Resolves the layout method of the component. If the function returns false the mobile version should be rendered.
     * If the function returns true the desktop version should be rendered.
     * @property {function(): boolean}
     */
    _this.resolveDesktop = _this.isDesktop;

    /**
     * Overrides the settings data loaded from Sitecore
     * @property {Object} settings
     * @property {string} settings.mobileBackgroundImage
     * @property {string} settings.desktopBackgroundImage
     * @property {string} settings.expandAllLabel
     * @property {string} settings.shrinkAllLabel
     * @property {boolean} settings.allowMultipleItemsExpanded
     * @property {number} settings.expandItemOnLoad
     * @property {boolean} settings.expandAllOnLoad
     */
    _this.overrideSettings = {};
    return _this;
  }
  _inherits(WDHAccordionSpot, _WDHComponent);
  return _createClass(WDHAccordionSpot, [{
    key: "isDesktop",
    value: function isDesktop() {
      return window.matchMedia('(min-width: 992px)').matches;
    }
  }, {
    key: "init",
    value: function init(component) {
      var settings = this.getSettingsFromComponent(component);
      ReactDOM.render(/*#__PURE__*/React.createElement(this.reactApp, {
        settings: settings,
        resolveDesktop: this.resolveDesktop
      }), component.querySelector('.component-content'));
    }

    /**
     * Get the rendered settings for the component instance given by *component*
     * @param component
     * @private
     */
  }, {
    key: "getSettingsFromComponent",
    value: function getSettingsFromComponent(component) {
      var settingsElement = component.querySelector('script[type="application/json"]');
      var settings = {};
      try {
        settings = JSON.parse(settingsElement.textContent);
      } catch (e) {
        settings.error = "".concat(e.name, " - ").concat(e.message);
      }
      settings = Object.assign(settings, this.overrideSettings);
      return settings;
    }
  }]);
}(WDHComponent);
export default WDHAccordionSpot;